import React, { useEffect, useState, useContext } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequestUser } from "../utils/azure/config";
import { useIsAuthenticated } from "@azure/msal-react";
import { GlobalState } from "../GlobalState";
import logoMyH from "../assets/images/logonMyh.png";
import { redirect, useNavigate } from "react-router-dom";
import { userEvent } from "../controller";
import { getMail } from "../utils/services";

export default function Login() {
  const navigate = useNavigate();
  const state = useContext(GlobalState);

  const { accounts, instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const [Auth, setAuth] = state.isAuthenticated;

  // Check for accessToken in URL params and fetch user info
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get('access_token');
    
    if (accessToken) {
      // console.log('AccessToken from URL:', accessToken);
      
      fetch(`https://adminsukien.myu.vn/apis_v1/user/userinfo?code=${accessToken}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => response.json())
        .then(data => {
          console.log('User info response:', data);
          sessionStorage.setItem('userInfoFromToken', JSON.stringify(data));
          sessionStorage.setItem('accessToken', accessToken);
        })
        .catch(error => {
          console.error('Error fetching user info:', error);
        });
    }
  }, []);

  // Handle redirect callback after login
  useEffect(() => {
    const handleRedirectCallback = async () => {
      if (isAuthenticated && accounts.length > 0) {
        const account = accounts[0];
        instance.setActiveAccount(account);
        
        // Get the ID token
        try {
          const response = await instance.acquireTokenSilent({
            ...loginRequestUser,
            account: account,
          });
          
          sessionStorage.setItem("mail", account.username);
          sessionStorage.setItem("account", JSON.stringify(account));
          sessionStorage.setItem("userInfo", JSON.stringify(response));
          
          const res = await userEvent.createUserEvent({
            mail: account.username,
            role: 0, // 0: user, 1: captain, 2: admin
            event: "minigametet2026",
            token: response.idToken,
          });
          
          if (res && res.ms365User) {
            window.sessionStorage.setItem("islogged", true);
            setAuth(true);
            sessionStorage.setItem("islogged", true);
            sessionStorage.setItem("modeLogin", "MS365");
            sessionStorage.setItem("ms365User", JSON.stringify(res.ms365User));
            localStorage.setItem("islogged", true);
            sessionStorage.setItem("userEvent", JSON.stringify(res.userEvent));
            navigate("/user/events/");
          }
        } catch (error) {
          console.error("Error acquiring token:", error);
        }
      }
    };
    
    handleRedirectCallback();
  }, [isAuthenticated, accounts, instance, setAuth, navigate]);

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     window.sessionStorage.setItem("islogged", true);
  //   }
  // }, [isAuthenticated]);

  const handleLogin = async () => {
    try {
      await instance.loginRedirect(loginRequestUser);
    } catch (err) {
      console.error("Login redirect failed:", err);
      // Check if error message contains "404" (user not found)
      if (err.message && err.message.includes("404")) {
        console.log("User not found (404), creating account...");
      } else {
        console.log("Other error, not 404");
      }
    }
  };

  return (
    <div className="bg-[#f6f6f6] w-full h-screen flex justify-center items-center p-2">
      <div className="shadow-lg rounded p-10 bg-white">
        <img src={logoMyH} alt="Logo Hung Hau" className="w-24 mx-auto" />
        {/* <p className="font-bold text-center text-gray-700 text-xl mt-4">Đăng nhập</p> */}
        <button
          onClick={handleLogin}
          className="flex justify-center py-5 px-20 border rounded my-3 hover:shadow hover:bg-slate-50 w-full items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 23 23"
            className="h-8"
          >
            <path fill="#f3f3f3" d="M0 0h23v23H0z" />{" "}
            <path fill="#f35325" d="M1 1h10v10H1z" />{" "}
            <path fill="#81bc06" d="M12 1h10v10H12z" />{" "}
            <path fill="#05a6f0" d="M1 12h10v10H1z" />{" "}
            <path fill="#ffba08" d="M12 12h10v10H12z" />
          </svg>
          <p className="ml-2 text-lg text-gray-600">Login with Office 365</p>
        </button>
      </div>
    </div>
  );
}
